import Swal from 'sweetalert2';

export const Alert = {
	error: (message,target = null) => {
		Swal.fire({
	        title: "",
	        text: message,
	        icon: "error",
			showCancelButton: false,
			confirmButtonColor: '#11175e',
			confirmButtonText: "Aceptar",
			target: target ? document.getElementById(target) : undefined
	    });
	}
}